import { Link } from "react-router-dom";
import Icon from "./Icon";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const logoBox = cva(
  "grid place-items-center rounded-full bg-gradient-to-br from-floodlight to-emerald-400 shadow-lg shadow-emerald-500/25",
  {
    variants: {
      size: {
        sm: "h-8 w-8",
        md: "h-10 w-10",
        lg: "h-14 w-14",
      },
    },
    defaultVariants: {
      size: "md",
    },
  }
);
const logoIcon = cva("text-ink", {
  variants: {
    size: {
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-7 w-7",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

const logoText = cva("font-extrabold text-white tracking-tight", {
  variants: {
    size: {
      sm: "text-sm",
      md: "text-lg",
      lg: "text-2xl",
    },
  },
  defaultVariants: { size: "md" },
});

export function Logo({ size, className, showText = true }) {
  return (
    <Link to="/" className={cn("flex items-center gap-2.5 shrink-0", className)}>
      <span className={logoBox({ size })}>
        <Icon name="trophy" className={logoIcon({ size })} />
      </span>
      {showText && (
        <span className={logoText({ size })}>هیئت فوتبال شهرستان پاوه</span>
      )}
    </Link>
  );
}

